import React from 'react'
import ProjectLanding from '../components/project-landing/ProjectLanding';
import Footer from '../components/footer/Footer'

function Projects() {
    return (
        <div className="project">
          
            <ProjectLanding/>
            <Footer/>
        </div>
    )
}

export default Projects
